export const downloadBlob = (data?: Blob, name?: string | null) => {
  if (data) {
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(data)
    link.download = name ?? 'file'
    link.click()
  }
}
